<h1 mat-dialog-title>{{ 'offer.translation.automatic.failed.title' | translate }}</h1>
<mat-dialog-content>
    <div class="ck-content">
        <p [innerHTML]="('offer.translation.automatic.failed.description' | translate)"></p>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="row x_center marges">
        <div class="col_content">
            <button class="btn_cta btn_little btn_red" (click)="dialogRef.close()">{{ 'action.close' | translate }}</button>
        </div>
    </div>
</mat-dialog-actions>

